import {fetch} from "./fetch";

const cache = new Map<string, Record<string, string>>();

export async function downloadTranslations(baseURL: string, language: string, country: string) {
    const response = await fetch(new URL(`${language}-${country}.json`, baseURL).href, {
        headers: {
            'Accept': 'application/json',
        }
    });
    cache.set(baseURL, await response.json());
}

export function getCountryFromUrl(url: Location | URL): string {
    // the second level of the URL path contains the correct region
    // de is fallback for localhost, should never execute on prod
    return url.pathname.split('/')[2] ?? 'de';
}

export function getCurrentCountry(): string {
    return getCountryFromUrl(location);
}

export function getCurrentLanguage(): string {
    return getLanguageFromUrl(location);
}

export function getLanguageFromUrl(url: Location | URL): string {
    // the second level of the URL path contains the correct region
    // de is fallback for localhost, should never execute on prod
    return url.pathname.split('/')[1] ?? 'de';
}

export function translate(baseURL: string, key: string, ...params: string[]): string {
    const map = cache.get(baseURL);
    const errorMsg = `[${key}]`;
    let translation = map?.[key] ?? errorMsg;

    params.forEach((p,i) => {
        const regex = new RegExp(`\\{\\$${i}\\}`, 'g');
        translation = translation.replace(regex, p);
    });

    return translation;
}
